import { Box } from '@fhs-legacy/universal-components';

export const BackButtonContainer = Box.withConfig({
  backgroundColor: Styles.color.cardBackground,
  padding: 4,
  paddingBottom: 0,
});
